// @ vendor
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_LOAD_STEP
} = require('../../insuranceConstants/actionTypes');

const { FLOW_STEPS } = require('../../insuranceConstants/insuranceRequestHome');

const setInitialState = () => {
    return Immutable.Map().merge({
        valid: false
    });
};

const validateStep = step => {
    return step.merge({
        valid: true
    });
};

const insuranceRequestRelatedRNCWizardStep1 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_VALIDATE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_LOAD_STEP:
            return state.merge({
                valid: FLOW_STEPS[action.data.flowData.uiStep] > FLOW_STEPS.STEP_1
            });
    }

    return state;
};

module.exports = insuranceRequestRelatedRNCWizardStep1;
